import { render, staticRenderFns } from "./SimpleField.vue?vue&type=template&id=bcfecf28&scoped=true&"
import script from "./SimpleField.vue?vue&type=script&lang=js&"
export * from "./SimpleField.vue?vue&type=script&lang=js&"
import style0 from "./SimpleField.vue?vue&type=style&index=0&id=bcfecf28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfecf28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
